import App from 'app';
import Catalog from 'components/home/catalog.jsx';
import Slider from 'components/home/slider.jsx';
import React, { useEffect, useRef, useState } from 'react';
import { GetProductCatalog } from 'services/Product';
import { GetUser, SetReferral } from 'services/Session';
import { GetSetting } from 'services/Setting';
import { handleError, handleRefresh } from 'utils/api.jsx';

export function Home(props) {
  let isHoliday = false
  let holidayMessage1 = 'Mohon maaf toko tutup sementara libur hari raya Idul Fitri 1446H.'
  let holidayMessage2 = 'InsyaAllah kami hadir kembali tanggal 14 April 2025.'
  let isShowRunningText = false
  let runningText = 'Mohon maaf toko sedang libur Idul Fitri 1446H, mulai pengiriman insyaallah tanggal 14 April 2024'
  const [user, setUser] = useState(GetUser());
  const [setting, setSetting] = useState({});
  const [catalogs, setCatalogs] = useState({
    count: 0,
    page_context: {
      page: 0,
      per_page: 0,
      total_pages: 0,
    },
    results: [],
  });
  const [highlights, setHighlights] = useState({
    count: 0,
    page_context: {
      page: 0,
      per_page: 0,
      total_pages: 0,
    },
    results: [],
  });
  const retryCountRef = useRef(0);

  const getCatalog = async () => {
    try {
      const { data } = await GetProductCatalog({ 
        'is_active': true, 
        'is_highlight': false, 
        'quantity.available.$gt': 0,
        'sorts': 'sort_number',
      });

      setCatalogs(data);
    } catch (err) {
      handleError(err, getCatalog, retryCountRef, true, setUser);
    }
  };

  const getHighlights = async () => {
    let q = require('query-string').parse(props.location.search)
    if (q && q.ref) {
      SetReferral(q.ref)
    }
    try {
      const { data } = await GetProductCatalog({ 
        'is_active': true,
        'is_highlight': true, 
        'sorts': 'sort_number',
      });

      setHighlights(data);
    } catch (err) {
      handleError(err, getHighlights, retryCountRef, true, setUser);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await GetSetting(setSetting);
      await handleRefresh(getCatalog, retryCountRef, true, setUser);
      await getHighlights();
    };

    getData();
  }, []);
  return (
    <App user={user} setting={setting}>
      {isShowRunningText && <marquee className='text-lg py-2 text-orange'>{runningText}</marquee>}
      {isHoliday ? <div className="w-[90%] max-w-[800px] py-4 my-4 m-auto text-center bg-white rounded border text-lg">{holidayMessage1}<br />{holidayMessage2}</div> : <>
        <Slider products={highlights} />
        <Catalog highlights={highlights} products={catalogs} />
      </>}
    </App>
  )
}